<template>
  <gj-popover lazy placement="bottom" width="220" v-model="visible" @show="show">
    <gj-charger-select
      v-model="chargeUserIds"
      collapse-tags
      placeholder="请选择销售负责人"
      active
      style="width: 220px"
      :disabled="!$permission('listing:editDuty')"
    >
    </gj-charger-select>
    <div style="text-align: right; margin: 20px 0 0">
      <el-button
        size="mini"
        type="text"
        @click="visible = false"
        style="border: 1px solid #1f6eef; height: 26px"
        >取消</el-button
      >
      <el-button
        type="primary"
        size="mini"
        @click="confirm"
        :loading="loading"
        style="height: 26px"
        >确定</el-button
      >
    </div>
    <i class="el-icon-edit" slot="reference" :disabled="false"></i>
  </gj-popover>
</template>

<script>
import { editGoodsCharge } from "@/api/sale";
export default {
  name: "edit-good-charge",
  props: {
    row: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      chargeUserIds: null,
    };
  },
  methods: {
    show() {
      this.chargeUserIds = this.row.charges;
    },
    confirm() {
      this.loading = true;
      const params = {
        listingId: this.row.id,
        chargeUserIds: this.chargeUserIds,
      };
      editGoodsCharge(params)
        .then(() => {
          this.visible = false;
          this.$emit("editSucc");
        })
        .complete(() => (this.loading = false));
    },
  },
};
</script>
